<!-- eslint-disable pct-custom-ng-rules/no-mat-icon-svg-icon -->
@let loadingValue = loading();
<button
  class="!absolute top-1 right-1 text-[silver]"
  mat-icon-button
  type="button"
  [disabled]="loadingValue"
  (click)="onClickClose()"
>
  <mat-icon svgIcon="pct-mdi-close" />
</button>

@if (loadingValue) {
  <mat-progress-spinner class="mx-auto" diameter="52" mode="indeterminate" />
} @else {
  <div class="flex-1 mt-2 color-white">
    <p>Kívánja telepíteni az alkalmazást az eszközére?</p>
  </div>
}
<button mat-flat-button type="button" [disabled]="loadingValue" (click)="onClickInstall()"
  >Telepítés</button
>
